import { INode } from 'shared/types/tree'
import { getGradeId } from 'shared/utils/tree'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { gradesByIdAtom } from './grades.atoms'
import { useCallback } from 'react'

export function useGetGradeForTree() {
  const grades = useAtomValue(gradesByIdAtom)
  return useCallback(
    (tree: INode) => {
      const gradeId = getGradeId(tree)
      if (gradeId && gradeId in grades) {
        return grades[gradeId]
      }
    },
    [grades],
  )
}
